<template>
  <div :class="classes" role="tree" onselectstart="return false">
    <ul :class="containerClasses" role="group">
      <template v-for="(child, index) in data">
        <tree-item
          :key="`tree-item-${index}`"
          :data="child"
          :text-field-name="textFieldName"
          :value-field-name="valueFieldName"
          :children-field-name="childrenFieldName"
          :item-events="itemEvents"
          :whole-row="wholeRow"
          :show-checkbox="showCheckbox"
          :allow-transition="allowTransition && mode !== 'editor'"
          :height="sizeHeight"
          :parent-item="data"
          :on-item-click="onItemClick"
          :on-item-toggle="onItemToggle"
          :on-item-drag-start="onItemDragStart"
          :on-item-drag-end="onItemDragEnd"
          :on-item-drop="onItemDrop"
          :on-item-mouse-over="onItemMouseOver"
          :on-item-open-in-new-tab="onItemOpenInNewTab"
          :on-item-paginate="onItemPaginate"
          :klass="index === data.length - 1 ? 'tree-last' : ''"
          :draggable="resolveDraggableStatus(child)"
          :mode="mode"
          :role="role"
        >
          <template slot-scope="_">
            <slot :vm="_.vm" :model="_.model" v-if="_.model.visible">
              <svg
                v-if="_.vm.themeIconClasses[2].hasOwnProperty('custom custom-camera')"
                xmlns="http://www.w3.org/2000/svg"
                width="17.039"
                height="17.067"
                viewBox="0 0 17.039 17.067"
                style="margin-right: 8px; margin-left: 5px"
              >
                <g transform="translate(-5 -6.53)">
                  <path
                    d="M21.3,6.53H5.743A.745.745,0,0,0,5,7.273v2.812a.745.745,0,0,0,.743.743h.634v4.56a7.143,7.143,0,1,0,14.286,0V10.824H21.3a.745.745,0,0,0,.743-.743V7.273A.745.745,0,0,0,21.3,6.53Zm-1.315,8.857a6.461,6.461,0,0,1-12.923,0V10.824H19.978v4.563Zm1.377-5.306a.061.061,0,0,1-.061.061H5.743a.061.061,0,0,1-.061-.061V7.273a.061.061,0,0,1,.061-.061H21.3a.061.061,0,0,1,.061.061Z"
                    fill="#fff"
                  />
                  <path
                    d="M22.05,31.466a4.108,4.108,0,1,0-4.11-4.107A4.115,4.115,0,0,0,22.05,31.466Zm0-7.535a3.427,3.427,0,1,1-3.428,3.425A3.433,3.433,0,0,1,22.05,23.932Z"
                    transform="translate(-8.53 -11.022)"
                    fill="#fff"
                  />
                  <path
                    d="M26.79,33.749a1.66,1.66,0,1,0-1.66-1.66A1.662,1.662,0,0,0,26.79,33.749Zm0-2.634a.978.978,0,1,1-.978.978A.98.98,0,0,1,26.79,31.115Z"
                    transform="translate(-13.27 -15.755)"
                    fill="#fff"
                  />
                </g>
                <g
                  transform="translate(10.934 11.067)"
                  fill="#f53214"
                  stroke="#fff"
                  stroke-width="1"
                >
                  <circle cx="3" cy="3" r="3" stroke="none" />
                  <circle cx="3" cy="3" r="2.5" fill="none" />
                </g>
              </svg>
              <svg
                v-else-if="_.vm.themeIconClasses[2].hasOwnProperty('custom custom-web')"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 16 16"
                style="margin-right: 8px; margin-left: 5px"
              >
                <path
                  class="icon"
                  d="M7.571,13.286a1.143,1.143,0,1,0-1.143-1.143A1.143,1.143,0,0,0,7.571,13.286Zm4.571-1.143A1.143,1.143,0,1,1,11,11,1.143,1.143,0,0,1,12.143,12.143Zm2.286,1.143a1.143,1.143,0,1,0-1.143-1.143A1.143,1.143,0,0,0,14.429,13.286ZM3,5.857A2.857,2.857,0,0,1,5.857,3H16.143A2.857,2.857,0,0,1,19,5.857V16.143A2.857,2.857,0,0,1,16.143,19H5.857A2.857,2.857,0,0,1,3,16.143ZM5.857,4.143A1.714,1.714,0,0,0,4.143,5.857V16.143a1.714,1.714,0,0,0,1.714,1.714H16.143a1.714,1.714,0,0,0,1.714-1.714V7.571H10.429A1.714,1.714,0,0,1,8.714,5.857V4.143Zm12,1.714a1.714,1.714,0,0,0-1.714-1.714H9.857V5.857a.571.571,0,0,0,.571.571h7.429Z"
                  transform="translate(-3 -3)"
                  fill="#fff"
                />
              </svg>
              <svg
                v-else-if="
                  _.vm.themeIconClasses[2].hasOwnProperty('custom custom-camera-online')
                "
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 15.867 15.867"
                style="margin-right: 8px; margin-left: 5px"
              >
                <g fill="rgba(106,235,32,0.7)">
                  <path
                    d="M 7.933594226837158 15.11718463897705 C 3.972554206848145 15.11718463897705 0.7500042319297791 11.89463424682617 0.7500042319297791 7.933594226837158 C 0.7500042319297791 3.972554206848145 3.972554206848145 0.7500042319297791 7.933594226837158 0.7500042319297791 C 11.89463424682617 0.7500042319297791 15.11718463897705 3.972554206848145 15.11718463897705 7.933594226837158 C 15.11718463897705 11.89463424682617 11.89463424682617 15.11718463897705 7.933594226837158 15.11718463897705 Z"
                    stroke="none"
                  />
                  <path
                    d="M 7.933594226837158 1.500003814697266 C 4.386104583740234 1.500003814697266 1.500003814697266 4.386104583740234 1.500003814697266 7.933594226837158 C 1.500003814697266 11.4810848236084 4.386104583740234 14.36718463897705 7.933594226837158 14.36718463897705 C 11.4810848236084 14.36718463897705 14.36718463897705 11.4810848236084 14.36718463897705 7.933594226837158 C 14.36718463897705 4.386104583740234 11.4810848236084 1.500003814697266 7.933594226837158 1.500003814697266 M 7.933594226837158 3.814697265625e-06 C 12.31519412994385 3.814697265625e-06 15.86718463897705 3.551994323730469 15.86718463897705 7.933594226837158 C 15.86718463897705 12.31519412994385 12.31519412994385 15.86718463897705 7.933594226837158 15.86718463897705 C 3.551994323730469 15.86718463897705 3.814697265625e-06 12.31519412994385 3.814697265625e-06 7.933594226837158 C 3.814697265625e-06 3.551994323730469 3.551994323730469 3.814697265625e-06 7.933594226837158 3.814697265625e-06 Z"
                    stroke="none"
                    fill="#fff"
                  />
                </g>
              </svg>
              <svg
                v-else-if="
                _.vm.themeIconClasses[2].hasOwnProperty('custom custom-circle-offline-orange')"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 15.867 15.867"
                style="margin-right: 8px; margin-left: 5px"
              >
                <g fill="rgba(255, 160, 60, .8)">
                  <path
                    d="M 7.933594226837158 15.11718463897705 C 3.972554206848145 15.11718463897705 0.7500042319297791 11.89463424682617 0.7500042319297791 7.933594226837158 C 0.7500042319297791 3.972554206848145 3.972554206848145 0.7500042319297791 7.933594226837158 0.7500042319297791 C 11.89463424682617 0.7500042319297791 15.11718463897705 3.972554206848145 15.11718463897705 7.933594226837158 C 15.11718463897705 11.89463424682617 11.89463424682617 15.11718463897705 7.933594226837158 15.11718463897705 Z"
                    stroke="none"
                  />
                  <path
                    d="M 7.933594226837158 1.500003814697266 C 4.386104583740234 1.500003814697266 1.500003814697266 4.386104583740234 1.500003814697266 7.933594226837158 C 1.500003814697266 11.4810848236084 4.386104583740234 14.36718463897705 7.933594226837158 14.36718463897705 C 11.4810848236084 14.36718463897705 14.36718463897705 11.4810848236084 14.36718463897705 7.933594226837158 C 14.36718463897705 4.386104583740234 11.4810848236084 1.500003814697266 7.933594226837158 1.500003814697266 M 7.933594226837158 3.814697265625e-06 C 12.31519412994385 3.814697265625e-06 15.86718463897705 3.551994323730469 15.86718463897705 7.933594226837158 C 15.86718463897705 12.31519412994385 12.31519412994385 15.86718463897705 7.933594226837158 15.86718463897705 C 3.551994323730469 15.86718463897705 3.814697265625e-06 12.31519412994385 3.814697265625e-06 7.933594226837158 C 3.814697265625e-06 3.551994323730469 3.551994323730469 3.814697265625e-06 7.933594226837158 3.814697265625e-06 Z"
                    stroke="none"
                    fill="#fff"
                  />
                </g>
              </svg>
              <svg
                v-else-if="
                  _.vm.themeIconClasses[2].hasOwnProperty('custom custom-camera-offline')
                "
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 15.867 15.867"
                style="margin-right: 8px; margin-left: 5px"
              >
                <g fill="rgba(245, 50, 20, .6)">
                  <path
                    d="M 7.933594226837158 15.11718463897705 C 3.972554206848145 15.11718463897705 0.7500042319297791 11.89463424682617 0.7500042319297791 7.933594226837158 C 0.7500042319297791 3.972554206848145 3.972554206848145 0.7500042319297791 7.933594226837158 0.7500042319297791 C 11.89463424682617 0.7500042319297791 15.11718463897705 3.972554206848145 15.11718463897705 7.933594226837158 C 15.11718463897705 11.89463424682617 11.89463424682617 15.11718463897705 7.933594226837158 15.11718463897705 Z"
                    stroke="none"
                  />
                  <path
                    d="M 7.933594226837158 1.500003814697266 C 4.386104583740234 1.500003814697266 1.500003814697266 4.386104583740234 1.500003814697266 7.933594226837158 C 1.500003814697266 11.4810848236084 4.386104583740234 14.36718463897705 7.933594226837158 14.36718463897705 C 11.4810848236084 14.36718463897705 14.36718463897705 11.4810848236084 14.36718463897705 7.933594226837158 C 14.36718463897705 4.386104583740234 11.4810848236084 1.500003814697266 7.933594226837158 1.500003814697266 M 7.933594226837158 3.814697265625e-06 C 12.31519412994385 3.814697265625e-06 15.86718463897705 3.551994323730469 15.86718463897705 7.933594226837158 C 15.86718463897705 12.31519412994385 12.31519412994385 15.86718463897705 7.933594226837158 15.86718463897705 C 3.551994323730469 15.86718463897705 3.814697265625e-06 12.31519412994385 3.814697265625e-06 7.933594226837158 C 3.814697265625e-06 3.551994323730469 3.551994323730469 3.814697265625e-06 7.933594226837158 3.814697265625e-06 Z"
                    stroke="none"
                    fill="#fff"
                  />
                </g>
              </svg>
              <svg
                v-else-if="
                  _.vm.themeIconClasses[2].hasOwnProperty(
                    'custom custom-facestream-online'
                  )
                "
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                style="margin-right: 8px; margin-left: 5px"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-cast"
              >
                <path
                  d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"
                ></path>
                <line x1="2" y1="20" x2="2.01" y2="20"></line>
                <g
                  transform="translate(17 15)"
                  fill="#00FF00"
                  stroke="#fff"
                  stroke-width="1"
                >
                  <circle cx="4" cy="4" r="4" stroke="none" />
                  <circle cx="4" cy="4" r="3.5" fill="none" />
                </g>
              </svg>
              <svg
                v-else-if="
                  _.vm.themeIconClasses[2].hasOwnProperty(
                    'custom custom-facestream-offline'
                  )
                "
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                style="margin-right: 8px; margin-left: 5px"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-cast"
              >
                <path
                  d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"
                ></path>
                <line x1="2" y1="20" x2="2.01" y2="20"></line>
                <g
                  transform="translate(17 15)"
                  fill="#f53214"
                  stroke="#fff"
                  stroke-width="1"
                >
                  <circle cx="4" cy="4" r="4" stroke="none" />
                  <circle cx="4" cy="4" r="3.5" fill="none" />
                </g>
              </svg>
              <svg
                v-else-if="
                  _.vm.themeIconClasses[2].hasOwnProperty('custom custom-dmt-area')
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 24 24"
                width="14"
                height="14"
                style="margin-right: 8px; margin-left: 5px"
              >
                <path
                  d="M3 3h8v8H3zm0 10h8v8H3zM13 3h8v8h-8zm0 10h8v8h-8z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                v-else-if="
                  _.vm.themeIconClasses[2].hasOwnProperty('custom custom-door-dmt')
                "
                width="14"
                height="14"
                style="margin-right: 8px; margin-left: 5px"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 24 24"
              >
                <path
                  d="M20 2H4v20h16V2zm-4.5 11.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                v-else-if="
                  _.vm.themeIconClasses[2].hasOwnProperty('custom custom-output-dmt')
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 24 24"
                width="14"
                height="14"
                style="margin-right: 8px; margin-left: 5px"
              >
                <path
                  d="M17 17l5-5l-5-5l-1.41 1.41L18.17 11H9v2h9.17l-2.58 2.59z"
                  fill="currentColor"
                ></path>
                <path
                  d="M19 19H5V5h14v2h2V5a2 2 0 0 0-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-2h-2v2z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg
                v-else-if="
                  _.vm.themeIconClasses[2].hasOwnProperty('custom custom-zone-dmt')
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 24 24"
                width="14"
                height="14"
                style="margin-right: 8px; margin-left: 5px"
              >
                <path d="M3 3h18v18H3z" fill="currentColor"></path>
              </svg>
              <svg
                v-else-if="
                  _.vm.themeIconClasses[2].hasOwnProperty('custom custom-zone24-dmt')
                "
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 24 24"
                width="14"
                height="14"
                style="margin-right: 8px; margin-left: 5px"
              >
                <g fill="none">
                  <path
                    d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10s10-4.477 10-10zM7.5 8.744C7.847 8.362 8.415 8 9.25 8c1.152 0 1.894.792 2.155 1.661c.253.847.1 1.895-.62 2.618a8.092 8.092 0 0 1-.793.67l-.04.031c-.28.216-.53.412-.75.63c-.255.256-.464.535-.585.89h2.133a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75c0-1.247.524-2.083 1.144-2.701c.296-.296.618-.545.89-.756l.003-.002c.286-.221.508-.393.685-.57c.272-.274.367-.725.246-1.13c-.115-.381-.37-.591-.718-.591c-.353 0-.535.137-.64.253a.843.843 0 0 0-.148.229v.003a.75.75 0 0 1-1.428-.462l.035-.096a2.343 2.343 0 0 1 .43-.683zM13.25 8a.75.75 0 0 1 .75.75v2.75h1.5V8.75a.75.75 0 0 1 1.5 0v6.47a.75.75 0 0 1-1.5 0V13h-2.25a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75z"
                    fill="currentColor"
                  ></path>
                </g>
              </svg>
              <template v-else>
                <i
                  :class="_.vm.themeIconClasses"
                  role="presentation"
                  v-if="!_.model.loading"
                ></i>
              </template>
              <span
                v-if="_.model.in_project"
                class="tree-maintenance"
              >
                <feather-icon
                  icon="ToolIcon"
                  size="12"
                  class="tree-maintenance__icon"
                />
                <span v-html="_.model[textFieldName]"></span>
              </span>
              <span v-else v-html="_.model[textFieldName]"></span>
            </slot>
          </template>
        </tree-item>
      </template>
    </ul>
  </div>
</template>
<script>
import TreeItem from "./tree-item.vue";

let ITEM_ID = 0;
let ITEM_HEIGHT_SMALL = 18;
let ITEM_HEIGHT_DEFAULT = 24;
let ITEM_HEIGHT_LARGE = 32;

export default {
  props: {
    data: { type: Array | Object },
    size: { type: String, validator: (value) => ["large", "small"].indexOf(value) > -1 },
    showCheckbox: { type: Boolean, default: false },
    wholeRow: { type: Boolean, default: false },
    noDots: { type: Boolean, default: false },
    collapse: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    allowBatch: { type: Boolean, default: false },
    allowTransition: { type: Boolean, default: true },
    textFieldName: { type: String, default: "text" },
    valueFieldName: { type: String, default: "value" },
    childrenFieldName: { type: String, default: "children" },
    itemEvents: {
      type: Object,
      default: function () {
        return {};
      },
    },
    async: { type: Function },
    loadingText: { type: String, default: "Loading..." },
    klass: String,
    mode: { type: String, default: "widget" },
    role: { type: String, default: "disabled" },
    cbk: { type: Function },
  },
  data() {
    return {
      draggedItem: undefined,
      draggedElm: undefined,
      initializedData: null,
    };
  },
  computed: {
    classes() {
      return [
        { tree: true },
        { "tree-default": !this.size },
        { [`tree-default-${this.size}`]: !!this.size },
        { "tree-checkbox-selection": !!this.showCheckbox },
        { [this.klass]: !!this.klass },
      ];
    },
    containerClasses() {
      return [
        { "tree-container-ul": true },
        { "tree-children": true },
        { "tree-wholerow-ul": !!this.wholeRow },
        { "tree-no-dots": !!this.noDots },
      ];
    },
    sizeHeight() {
      switch (this.size) {
        case "large":
          return ITEM_HEIGHT_LARGE;
        case "small":
          return ITEM_HEIGHT_SMALL;
        default:
          return ITEM_HEIGHT_DEFAULT;
      }
    },
  },
  methods: {
    initializeData(items) {
      if (items && items.length > 0) {
        for (let i in items) {
          var dataItem = this.initializeDataItem(items[i]);
          items[i] = dataItem;
          this.initializeData(items[i][this.childrenFieldName]);
        }
      }
    },
    initializeDataItem(item) {
      function Model(item, textFieldName, valueFieldName, childrenFieldName, collapse) {
        if (Array.isArray(item)) item = item[0]
        this.id = item.id || ITEM_ID++;
        this[textFieldName] = item[textFieldName] || "";
        this[valueFieldName] = item[valueFieldName] || item[textFieldName];
        this.icon = item.icon || "";
        this.opened = item.opened || collapse;
        this.selected = item.selected || false;
        this.disabled = item.disabled || false;
        this.loading = item.loading || false;
        this[childrenFieldName] = item[childrenFieldName] || [];
      }

      let node = Object.assign(
        new Model(
          item,
          this.textFieldName,
          this.valueFieldName,
          this.childrenFieldName,
          this.collapse
        ),
        item
      );
      if (item.tag === "url") node[this.textFieldName] = item.unit_data.description;
      let self = this;
      node.addBefore = function (data, selectedNode) {
        let newItem = self.initializeDataItem(data);
        let index = selectedNode.parentItem.findIndex((t) => t.id === node.id);
        selectedNode.parentItem.splice(index, 0, newItem);
      };
      node.addAfter = function (data, selectedNode) {
        let newItem = self.initializeDataItem(data);
        let index = selectedNode.parentItem.findIndex((t) => t.id === node.id) + 1;
        selectedNode.parentItem.splice(index, 0, newItem);
      };
      node.addChild = function (data) {
        let newItem = self.initializeDataItem(data);
        node.opened = true;
        node[self.childrenFieldName].push(newItem);
      };
      node.openChildren = function () {
        node.opened = true;
        self.handleRecursionNodeChildren(node, (node) => {
          node.opened = true;
        });
      };
      node.closeChildren = function () {
        node.opened = false;
        self.handleRecursionNodeChildren(node, (node) => {
          node.opened = false;
        });
      };
      return node;
    },
    initializeLoading() {
      var item = {};
      item[this.textFieldName] = this.loadingText;
      item.disabled = true;
      item.loading = true;
      return this.initializeDataItem(item);
    },
    handleRecursionNodeChilds(node, func) {
      if (func(node) !== false) {
        if (node.$children && node.$children.length > 0) {
          for (let childNode of node.$children) {
            if (!childNode.disabled) {
              this.handleRecursionNodeChilds(childNode, func);
            }
          }
        }
      }
    },
    handleRecursionNodeChildren(node, func) {
      if (func(node) !== false) {
        if (node[this.childrenFieldName] && node[this.childrenFieldName].length > 0) {
          for (let childNode of node[this.childrenFieldName]) {
            this.handleRecursionNodeChildren(childNode, func);
          }
        }
      }
    },
    onItemClick(oriNode, oriItem, e) {
      if (this.multiple) {
        if (this.allowBatch) {
          this.handleBatchSelectItems(oriNode, oriItem);
        }
      } else {
        this.handleSingleSelectItems(oriNode, oriItem);
      }
      this.$emit("item-click", oriNode, oriItem, e);
    },
    handleSingleSelectItems(oriNode, oriItem) {
      this.handleRecursionNodeChilds(this, (node) => {
        if (node.model) node.model.selected = false;
      });
      oriNode.model.selected = true;
    },
    handleBatchSelectItems(oriNode, oriItem) {
      this.handleRecursionNodeChilds(oriNode, (node) => {
        if (node.model.disabled) return;
        node.model.selected = oriNode.model.selected;
      });
    },
    onItemMouseOver(oriNode, oriItem) {
      this.$emit("item-mouse-over", oriNode, oriItem);
    },
    onItemOpenInNewTab(oriNode, oriItem, e) {
      //send the event to the parent
      this.$emit("item-open-in-new-tab", oriNode, oriItem, e);
    },
    onItemToggle(oriNode, oriItem, e) {
      if (oriNode.model.opened) {
        this.handleAsyncLoad(oriNode.model[this.childrenFieldName], oriNode, oriItem);
      }
      this.$emit("item-toggle", oriNode, oriItem, e);
    },
    onItemPaginate(oriNode, oriItem, page) {
      this.$emit("item-paginate", oriNode, oriItem, page);
    },
    handleAsyncLoad(oriParent, oriNode, oriItem) {
      var self = this;
      if (this.async) {
        if (oriParent[0].loading) {
          this.async(oriNode, (data) => {
            if (data.length > 0) {
              for (let i in data) {
                if (!data[i].isLeaf) {
                  if (typeof data[i][self.childrenFieldName] !== "object") {
                    data[i][self.childrenFieldName] = [self.initializeLoading()];
                  }
                }
                var dataItem = self.initializeDataItem(data[i]);
                self.$set(oriParent, i, dataItem);
              }
            } else {
              oriNode.model[self.childrenFieldName] = [];
            }
          });
        }
      }
    },
    resolveDraggableStatus(child) {
      if (this.mode === "editor") {
        return true;
      }
      return false;
    },
    onItemDragStart(e, oriNode, oriItem) {
      if (this.mode === "editor" && this.role === "source") {
        let parent = null;
        if (e.target.dataset.parent) parent = JSON.parse(e.target.dataset.parent);
        this.cbk(oriItem);

        const data = {
          item: oriItem,
          parent: parent && parent.tag === "video" ? null : parent,
        };
        e.dataTransfer.effectAllowed = "copy";
        e.dataTransfer.setData("text", JSON.stringify(data));
        this.$emit("item-drag-start", oriNode, oriItem, e);

        // ===================================
      } else if (this.mode === "editor" && this.role === "destination") {
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("text", null);

        this.draggedElm = e.target;
        this.draggedItem = {
          item: oriItem,
          parentItem: oriNode.parentItem,
          index: oriNode.parentItem.findIndex((t) => t.id === oriItem.id),
        };
        this.$emit("item-drag-start", oriNode, oriItem, e);

        // ===================================
      } else {
        e.stopPropagation();
        this.$emit("item-drag-start", oriItem);
        e.target.style.opacity = 0.4;

        // ===================================
      }
    },
    onItemDragEnd(e, oriNode, oriItem) {
      if (this.mode === "editor" && this.role === "source") {
        this.draggedItem = undefined;
        this.draggedElm = undefined;
        this.$emit("item-drag-end", oriNode, oriItem, e);

        // ===================================
      } else if (this.mode === "editor" && this.role === "destination") {
        this.draggedItem = undefined;
        this.draggedElm = undefined;
        this.$emit("item-drag-end", oriNode, oriItem, e);

        // ===================================
      } else {
        e.stopPropagation();
        this.$emit("item-drag-end");
        e.target.style.opacity = 1;
      }
    },
    onItemDrop(e, oriNode, oriItem) {
      if (this.mode !== "editor") return;
      if (this.mode === "editor" && this.role !== "destination") return;
      if (oriItem.type === "action") return;

      if (e.dataTransfer.getData("text") !== "null") {
        const newData = JSON.parse(e.dataTransfer.getData("text"));
        const item = newData.item;
        const sourceParent = newData.parent
          ? this.initializeDataItem(newData.parent)
          : null;
        let parentExists = false;

        this.draggedItem = {
          item,
          parentItem: oriNode,
          id: newData.id,
        };

        parentExists =
          sourceParent &&
          oriItem[this.childrenFieldName].findIndex((t) => t.id === sourceParent.id) !==
            -1;

        if (sourceParent) {
          if (parentExists) {
            const parent = oriItem[this.childrenFieldName].find(
              (t) => t.id === sourceParent.id
            );

            if (parent && parent.children.findIndex((t) => t.id === item.id) !== -1) {
              return;
            }

            if (oriItem.id === parent.id) {
              return;
            }

            parent.addChild(item);
          } else {
            if (oriItem.id === sourceParent.id) {
              if (
                oriItem[this.childrenFieldName].findIndex((t) => t.id === item.id) !== -1
              ) {
                return;
              }

              if (!!oriItem[this.childrenFieldName]) {
                oriItem[this.childrenFieldName].push(item);
              } else {
                oriItem[this.childrenFieldName] = [item];
              }
            } else {
              sourceParent.addChild(item);

              if (!!oriItem[this.childrenFieldName]) {
                oriItem[this.childrenFieldName].push(sourceParent);
              } else {
                oriItem[this.childrenFieldName] = [sourceParent];
              }
            }
          }
        } else {
          if (oriItem[this.childrenFieldName].findIndex((t) => t.id === item.id) !== -1) {
            return;
          }

          if (!!oriItem[this.childrenFieldName]) {
            oriItem[this.childrenFieldName].push(item);
          } else {
            oriItem[this.childrenFieldName] = [item];
          }
        }

        // if (
        //   oriItem[this.childrenFieldName] &&
        //   oriItem[this.childrenFieldName].findIndex((t) => t.id === item.id) !== -1
        // ) {
        //   return;
        // }

        // if (!!oriItem[this.childrenFieldName]) {
        //   oriItem[this.childrenFieldName].push(item);
        // } else {
        //   oriItem[this.childrenFieldName] = [item];
        // }
        // oriItem[this.childrenFieldName].sort((a, b) => a.text - b.text);

        oriItem.opened = true;
      } else {
        if (
          !this.draggedElm ||
          this.draggedElm === e.target ||
          this.draggedElm.contains(e.target)
        ) {
          return;
        }

        if (this.draggedItem) {
          if (
            this.draggedItem.parentItem === oriItem[this.childrenFieldName] ||
            this.draggedItem.item === oriItem ||
            (oriItem[this.childrenFieldName] &&
              oriItem[this.childrenFieldName].findIndex(
                (t) => t.id === this.draggedItem.item.id
              ) !== -1)
          ) {
            return;
          }
          if (!!oriItem[this.childrenFieldName]) {
            oriItem[this.childrenFieldName].push(this.draggedItem.item);
          } else {
            oriItem[this.childrenFieldName] = [this.draggedItem.item];
          }
          oriItem.opened = true;
          var draggedItem = this.draggedItem;
          this.$nextTick(() => {
            draggedItem.parentItem.splice(draggedItem.index, 1);
          });
          this.$emit("item-drop", oriNode, oriItem, draggedItem.item, e);
        }
      }
    },
  },
  created() {
    // this.initializeData(this.data);
  },
  mounted() {
    if (this.async) {
      this.$set(this.data, 0, this.initializeLoading());
      this.handleAsyncLoad(this.data, this);
    }
  },
  components: {
    TreeItem,
  },
};
</script>

<style>
.customBtnPagination {
  width: 18px;
  height: 18px;
  font-size: 16px;
  line-height: 1;
}
.tree-facilities-pager .pagination-count {
  font-size: 0.8rem;
}

.tree-maintenance {
  display: inline-flex;
  align-items: center;
  padding: 0 0.3rem;
  line-height: 1.5;
  vertical-align: -2px;
  border: 1px solid rgba(var(--warning-rgb), 0.55);
  border-radius: 0.4rem;
  background-color: rgba(var(--warning-rgb), 0.18);
}
.tree-maintenance__icon {
  display: flex;
  margin-right: 0.25rem;
  color: var(--warning);
}
</style>
